import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
  },
  leftSection: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  alertTitle: {
    fontFamily: "Roboto",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    letterSpacing: "0%",
    marginBottom: "8px",
    color: "#A0650E",
    gap: "8px",
  },
  alertText: {
    fontFamily: "Roboto",
    fontWeight: "400 !important",
    fontSize: "16px",
    lineHeight: "100%",
    letterSpacing: "0%",
    color: "#A0650E",
    display: "flex",
    gap: "8px",
  },
  deactivatedInfo: {
    marginLeft: "32px",
    display: "flex",
    alignItems: "center",
  },
  showMoreContainer: {
    display: "flex",
    alignItems: "flex-start",
    gap: "4px",
    marginLeft: "8px",
    whiteSpace: "nowrap",
    cursor: "pointer",
  },
  showMoreText: {
    fontFamily: "Roboto",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    letterSpacing: "0%",
    color: "#A0650E",
  },
  accordionDetails: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  detailsContainer: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "28px",
    padding: "4px 0px 10px",
  },
  iconSpacing: {
    verticalAlign: "middle",
    marginRight: "6px",
  },
  separator: {
    margin: "0 8px",
  },
});
